/* import __COLOCATED_TEMPLATE__ from './schematic-area.hbs'; */
/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { inject as service } from '@ember/service';
import { scheduleOnce } from '@ember/runloop';
import utilities from '../utils/utilities';
import $ from 'jquery';
import { eng3 } from '@ebiz/pretty-num';
import { modifier } from 'ember-modifier';

var getWidth = function () {
  return Number($('#centeredInputPanel').width());
};

var setFontSize = function (locale) {
  var bigger = getWidth() * 0.045 + 'px',
    normal = getWidth() * 0.0331 > 12.6 ? 12.6 : getWidth() * 0.0331,
    normalLineHeight = (getWidth() * 0.0326 > 16.5 ? 16.5 : getWidth() * 0.0326 + 2) + 'px';

  $(
    '.custom-output.schematic-label, .custom-output.schematic-label input[type="text"], #gainInputDiscrete select.form-control, #gainInputMultipleStages select.form-control, #gainStagesContainer select.form-control',
  ).css('font-size', normal + 'px');
  $('#signalTypeInput select.form-control').css('font-size', normal + 1.5 + 'px');
  if (locale === 'ru') {
    $('#resetPartButton, #closeGainPopoverButton').css('font-size', '12px');
  } else {
    $('#resetPartButton, #closeGainPopoverButton').css('font-size', normal + 1.5 + 'px');
  }
  $('.custom-output.schematic-label.label-xl').css('font-size', bigger);
  $('.custom-output.schematic-label, .custom-output.schematic-label input[type="text"]').css(
    'line-height',
    normalLineHeight,
  );
  $('#resetPartButton, #closeGainPopoverButton').css('padding', getWidth() * 0.01 + 'px ' + (getWidth() * 0.02 + 'px'));
  $(
    '#gainInputDiscrete select.form-control, #gainInputMultipleStages select.form-control, #gainStagesContainer select.form-control',
  ).css('width', getWidth() * 0.19 + 'px');
  $('#signalTypeInput select.form-control').css('width', getWidth() * 0.36 + 'px');
  $(
    '.custom-output.schematic-label input[type="text"], #gainInputDiscrete select.form-control, #gainInputMultipleStages select.form-control, #gainStagesContainer select.form-control',
  ).css('height', getWidth() * 0.066 + 'px');
  $('#signalTypeInput select.form-control').css('height', getWidth() * 0.069 + 'px');
  $('.custom-output.schematic-label input[type="text"]').css('width', getWidth() * 0.13 + 'px');
  $('.custom-output.schematic-label input[type="text"]').css('padding', getWidth() * 0.0115 + 'px');
};

var getSvgDimensions = function () {
  var size = getWidth(),
    width = size * 0.79,
    height = 0.8 * width;

  return [width, height];
};

var setSizes = function (locale) {
  $('#input-panel').css('height', 0.72 * getWidth());
  setFontSize(locale);
};

var displayInAmp = function (inputConfig, part, isInf, u, context) {
  baseDisplayAmp('InAmp.svg', inputConfig, part, isInf, u, context);
};

var display3AmpClamped = function (inputConfig, part, isInf, u, context) {
  baseDisplayAmp('InAmpClamped.svg', inputConfig, part, isInf, u, context);
};

var displayDiffPGIAAmp = function (inputConfig, part, isInf, u, context) {
  baseDisplayAmp('DiffPGIA.svg', inputConfig, part, isInf, u, context);
};

var baseDisplayAmp = function (svgName, inputConfig, part, isInf, u, context) {
  var gains = part.gainInputs,
    gain = part.selectedGainInput;

  setSizes(context.site.AdiLocale);

  u.loadSvg(svgName, $('#svg-area'), function () {
    var dimensions = getSvgDimensions();
    $('svg', context.schematicElement).css('width', dimensions[0]);
    $('svg', context.schematicElement).css('height', dimensions[1]);

    var hiddenSections = [];

    switch (inputConfig) {
      case 1:
        hiddenSections.push('#Single_Input_at_Minus', '#Single_Input_at_Plus_1_');
        break;
      case 2:
        hiddenSections.push('#Diif_Input', '#Single_Input_at_Plus_1_');
        break;
      case 3:
        hiddenSections.push('#Diif_Input', '#Single_Input_at_Minus');
        break;
    }

    if (part.diagramType.toUpperCase() !== 'PINSTRAPPED') {
      hiddenSections.push('#Pin_Strapped_Short');
      if (!isInf) hiddenSections.push('#Pin_Strapped_Open');
      else hiddenSections.push('#RgSchematic');
    } else {
      var smaller = Math.min(gains[0].id, gains[1].id),
        larger = Math.max(gains[0].id, gains[1].id);

      hiddenSections.push('#RgSchematic');

      if (part.inAmpType == '2amp') {
        // added to deal with pinstrapped 2amp parts - LTC
        hiddenSections.push('#Pin_Strapped_Short');
        hiddenSections.push('#Pin_Strapped_Open');
      } else {
        switch (gain.id) {
          case smaller:
            hiddenSections.push('#Pin_Strapped_Short');
            break;
          case larger:
            hiddenSections.push('#Pin_Strapped_Open');
            break;
          default:
            break;
        }
      }
    }

    if (part.gainType != 'range' || part.inAmpType == 'current') {
      hiddenSections.push('#RgSchematic');
    }

    if (part.inAmpType === 'diff3ampPGIA') {
      hiddenSections.push('#secondNegSupply');
    }

    if (!context.showFirstNegSupply) hiddenSections.push('#schematic_firstNegSupply');

    if (part.inAmpType == 'current') {
      if (gain.id == 1) {
        hiddenSections.push('#FB_Resistors');
      } else {
        hiddenSections.push('#FB_Gain_One');
      }
    } else {
      hiddenSections.push('#FB_Resistors', '#FB_Gain_One');
    }

    $(hiddenSections.join(', ')).hide();
  });
};

////////////////////////////////////////////////////////////////////////////////////
// schematic-area - Component containing the In-Amp Circuit with inputs           //
////////////////////////////////////////////////////////////////////////////////////

export default class SchematicArea extends Component {
  tagName = '';
  @service('aditools-analytics') analytics;
  @service site;
  schematicElement = null;
  schematicNarrow = false;
  boundResizeListener = null;
  inputErrors = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Modifer                                                                    //
  ////////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line no-unused-vars
  insertingSchematic = modifier((element, [_selectedPart, _selectedGainInput, _currentSignalType]) => {
    this.set('schematicElement', element);
    this.drawSchematic();

    this.boundResizeListener = this.onWindowResize.bind(this);
    window.addEventListener('resize', this.boundResizeListener);
    scheduleOnce('afterRender', this, this.onWindowResize);

    return () => {
      window.removeEventListener('resize', this.boundResizeListener);
      this.set('schematicElement', null);
    };
  });

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('vOutLeft') get vOutLeftDisplay() {
    return eng3(this.vOutLeft);
  }

  @computed('vOutRight') get vOutRightDisplay() {
    return eng3(this.vOutRight);
  }

  @computed('rg') get rgDisplay() {
    return this.rg.toLowerCase() === 'open' ? 'open' : eng3(this.rg) + 'Ω';
  }

  @computed('isValidGain', 'displayGainResult', 'isDiffPGIASchematic') get displayRg() {
    // should rg be displayed
    return this.isValidGain && this.displayGainResult && !this.isDiffPGIASchematic;
  }

  @computed('currentSignalType.id') get isDifferentialSignal() {
    return this.currentSignalType.id === 1;
  }

  @computed('currentSignalType.id') get isNegativeSignal() {
    return this.currentSignalType.id === 2;
  }

  @computed('currentSignalType.id') get isPositiveSignal() {
    return this.currentSignalType.id === 3;
  }

  @computed('currentGainStages') get isMultipleGainStages() {
    return this.currentGainStages.length > 1;
  }

  @computed('currentGainStages', 'selectedPart.{inputSelectedGainInput,outputSelectedGainInput}')
  get templateGainStages() {
    return this.currentGainStages
      .filter((stage) => stage)
      .map((stage) => {
        return {
          labelIntlKey: `inputMain.gain.${stage}`,
          id: `${stage}SelectedGainInput`,
          fieldId: `selectedPart.${stage}SelectedGainInput`,
          options: this.selectedPart[`${stage}GainInputs`],
          selectedValue: this.selectedPart[`${stage}SelectedGainInput`],
          value: stage,
        };
      });
  }

  @computed('selectedPart.gainType', 'isMultipleGainStages') get isRangeGainType() {
    return !this.isMultipleGainStages && this.selectedPart.gainType.toLowerCase() === 'range';
  }

  @computed('selectedPart.gainType', 'isMultipleGainStages') get isDiscreteGainType() {
    return !this.isMultipleGainStages && this.selectedPart.gainType.toLowerCase() === 'discrete';
  }

  @computed('selectedPart.gainType', 'isMultipleGainStages') get isFixedGainType() {
    return !this.isMultipleGainStages && this.selectedPart.gainType.toLowerCase() === 'fixed';
  }

  @computed('validationResults.isGain') get isValidGain() {
    return this.validationResults.isGain === true;
  }

  @computed('selectedPart.{gainType,rNumerator,diagramType}') get displayGainResult() {
    var gainType = this.selectedPart.gainType.toLowerCase(),
      rNumerator = this.selectedPart.rNumerator,
      diagramType = this.selectedPart.diagramType.toUpperCase();
    return rNumerator !== '' && (gainType === 'range' || diagramType === 'PINSTRAPPED');
  }

  @computed('validationResults.{isOperatingRange,isAllValid}') get vOutValid() {
    return this.validationResults.isOperatingRange && this.validationResults.isAllValid;
  }

  @computed('selectedPart.id') get hasPartNumberLink() {
    return this.selectedPart.id !== 'ideal3Amp';
  }

  @computed('inputErrors') get vsNegInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vsNegInput'));
  }

  @computed('inputErrors') get vsPosInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vsPosInput'));
  }

  @computed('inputErrors') get vddcpInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vddcpInput'));
  }

  @computed('inputErrors') get vrefInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vrefInput'));
  }

  @computed('inputErrors') get ref2InputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vref2Input'));
  }

  @computed('inputErrors') get ref1InputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vref1Input'));
  }

  @computed('inputErrors') get gainInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('gainInput'));
  }

  @computed('inputErrors') get vsPosOutputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vsPosOutput'));
  }

  @computed('inputErrors') get vsNegOutputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vsNegOutput'));
  }

  @computed('inputErrors') get vocmInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vocmInput'));
  }

  @computed('inputErrors') get vclhiInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vclhiInput'));
  }

  @computed('inputErrors') get vclloInputValid() {
    return !(this.inputErrors && this.inputErrors.fields.includes('vclloInput'));
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  onWindowResize() {
    let requiredWidth = 485;
    this.set('schematicNarrow', Number($('#input-container').width()) > requiredWidth ? false : true);
    this.drawSchematic();
  }

  drawSchematic() {
    if (this.isDiffPGIASchematic)
      displayDiffPGIAAmp(this.currentSignalType.id, this.selectedPart, this.rgInf, utilities, this);
    else if (this.isThreeAmpClampedSchematic)
      display3AmpClamped(this.currentSignalType.id, this.selectedPart, this.rgInf, utilities, this);
    else displayInAmp(this.currentSignalType.id, this.selectedPart, this.rgInf, utilities, this);
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action currentSignalTypeChanged(fieldId, value) {
    this.updateField(fieldId, value);
  }

  @action selectedGainChanged(fieldId, value) {
    let refresh = () => {
      this.refreshGainForSelectedPart();
    };
    this.updateField(fieldId, value, refresh);
  }

  @action selectedGainTextChanged(fieldId, value) {
    let refresh = () => {
      this.refreshGainForSelectedPart();
    };
    this.updateField(fieldId, value, refresh);
    this.selectedPart.selectedGainInput.description = value.toString();
  }

  @action updateProjectData(fieldId, value) {
    let refresh = () => {
      this.updateCalculatedProjectData();
    };
    this.updateField(fieldId, value, refresh);
  }

  @action insertingPartLink() {
    $(function () {
      $('.part-link-with-img').hover(
        function () {
          var e = $(this).find('>img:first-of-type');
          e.data('originalSrc', e.attr('src'));
          e.attr('src', e.attr('data-rollover'));
        },
        function () {
          var e = $(this).find('>img:first-of-type');
          e.attr('src', e.data('originalSrc'));
        },
      );
    });
  }

  @action partClick() {
    this.analytics.setWebEvent(this.toolName, 'productView', this.selectedPart.id);
  }
}
